import { searchUsersForMention as searchUsersForMentionModel } from 'APP/model/search/searchModel';
import { ISearchUsersForMentionResponse } from 'APP/model/search/searchModel.types';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';

const MENTIONS_LIMIT = 15;

export async function searchUsersForMention(
  inputPanel: InputPanel,
  filter: string,
  cursor: string | null = null
): Promise<ISearchUsersForMentionResponse> {
  const response = await searchUsersForMentionModel({
    cursor: cursor || undefined,
    groupId: inputPanel.groupId,
    limit: MENTIONS_LIMIT,
    prefix: filter,
  });

  const newCursor =
    response.users.length === 0 || response.cursor === inputPanel.mention.cursor
      ? null
      : response.cursor;

  return {
    ...response,
    cursor: newCursor || undefined,
  };
}
